<template>
  <div class="home">
    <Header></Header>
    <Banner></Banner>
    <div class="content">
        <div class="work">
            <Works></Works>
        </div>
        <div class="wrap-c content-c">
            <div class="form">
                <div class="form-c">
                    <h1 class="form-title large-title">Apply to become an Ambassador</h1>
                    <div class="color-gray text-c">nonda Ambassador program is a highly selective program, only limited applicants can join and earn 
    money with us. We will review your application and get back to you in 3 days. </div>
                    <div>
                        <el-form :model="form" :rules="rules" ref="ruleForm" label-width="0" class="demo-ruleForm">
                            <div class="ipt-form-c">
                                <el-form-item label="" prop="firstName">
                                    <el-input
                                    placeholder="First Name"
                                    v-model="form.firstName">
                                    <template #prefix>
                                        <img class="ipt-icon" src="../../assets/imgs/information/info.png" alt="">
                                    </template>
                                    </el-input>
                                </el-form-item>
                                <el-form-item label="" prop="lastName">
                                    <el-input
                                    placeholder="Last Name"
                                    v-model="form.lastName">
                                     <template #prefix>
                                        <img class="ipt-icon" src="../../assets/imgs/information/info.png" alt="">
                                    </template>
                                    </el-input>
                                </el-form-item>
                                <el-form-item label="" prop="email">
                                    <el-input
                                    placeholder="E-mail"
                                    v-model="form.email">
                                    <template #prefix>
                                        <img class="ipt-icon" style="margin:15px 0 0 6px" src="../../assets/imgs/information/email.png" alt="">
                                    </template>
                                    </el-input>
                                </el-form-item>
                                <el-form-item label="" prop="paypalAccount">
                                    <el-input
                                    placeholder="Your Paypal Account"
                                    v-model="form.paypalAccount">
                                    <template #prefix>
                                        <img class="ipt-icon" src="../../assets/imgs/information/paypal.png" alt="">
                                    </template>
                                    </el-input>
                                </el-form-item>
                                <div :class="paypalFlag ? 'change-form-c' : ''">
                                    <el-form-item label="" prop="checkPass">
                                        <el-input
                                            placeholder="Re-enter Your Paypal Account"
                                            v-model="form.checkPass">
                                            <template #prefix>
                                                <img class="ipt-icon" style="" src="../../assets/imgs/information/paypal.png" alt="">
                                            </template>
                                        </el-input>
                                    </el-form-item>
                                </div>
                                <div class="color-gray text-c">
                                    *This paypal account will be the one to receive payment from us under your email address. Please 
    make sure you enter the right one.
                                </div>
                                <div :class="phoneFlag ? 'change-form-c' : ''">
                                    <el-form-item label="" prop="phoneNum">
                                        <el-input
                                            placeholder="Phone Number"
                                            v-model="form.phoneNum">
                                            <template #prefix>
                                                <img class="ipt-icon" style="" src="../../assets/imgs/information/phone.png" alt="">
                                            </template>
                                        </el-input>
                                    </el-form-item>
                                </div>
                                <div class="color-gray text-c">*Please make sure this number is linked to your whatsapp account so our program director can add 
    you there and give you the latest incentive information.
                                </div>
                            </div>
                            <div class="texteray-c">
                                <el-form-item label="" prop="joinReason">
                                    <el-input
                                        type="textarea"
                                        :autosize="{ minRows: 4, maxRows: 4}"
                                        placeholder="Why do you want to join the nonda ambassador program?"
                                        v-model="form.joinReason">
                                    </el-input>
                                </el-form-item>
                                <el-form-item label="" prop="goodFit">
                                    <el-input
                                        type="textarea"
                                        :autosize="{ minRows: 4, maxRows: 4}"
                                        placeholder="Why do you think you are a good fit for the nonda ambassador program?"
                                        v-model="form.goodFit">
                                    </el-input>
                                </el-form-item>
                            </div>
                            <div class="checkbox-c">
                                <el-form-item label="" prop="checked">
                                    <el-checkbox v-model="form.checkedA" @change="handleCheckd">I agree to the <a target="_blank" href="https://nonda.zendesk.com/hc/en-us/articles/360059876131">Terms & Conditions</a> of the nonda ambassador program</el-checkbox>
                                </el-form-item>
                                <el-form-item label="" prop="phone">
                                    <el-checkbox v-model="form.checkedB" @change="handleCheckd">I pledge to not conduct any unlawful activities or abuse the program rules</el-checkbox>
                                </el-form-item>
                                <el-form-item label="" prop="phone">
                                    <el-checkbox v-model="form.checkedC" @change="handleCheckd">I pledge to do my best & help promote safe driving to people around me</el-checkbox>
                                </el-form-item>
                            </div>
                        </el-form>
                    </div>
                    <el-button :disabled="submitBtnDisabled" class="withdraw-btn" type="text" @click="submit">SUBMIT MY APPLICATION</el-button>
                </div>
            </div>
        </div>
    </div>
    <WithdrawlRecord></WithdrawlRecord>
    <div class="footer-nav">
        © Copyright No NDA Inc., All Rights Reserved
    </div>
    <el-dialog title="" v-model="dialogTableVisible" :show-close="false">
        <div class="dialog-box">
            <p>Thanks and you are all set.</p>
            <p>Due to the high number of applicants, we will review your application
                & get back to you in 2 business days. 
            </p>
            <p>Please check your email and stay tuned.</p>
            <br>
            <br>
            <p>Best</p>
            <p>James B.</p>
            <p>Director, nonda ambassador program</p>
            <el-button class="withdraw-btn" type="text" @click="goNonda">Go back to nonda.co</el-button>
        </div>
    </el-dialog>
  </div>
</template>

<script lang="ts">
import { edit } from "@/api/information"
import Header from "@/components/Header/index.vue";
import Banner from "./Banner.vue"
import Works from "@/components/Works/index.vue"
import WithdrawlRecord from "@/components/WithdrawalRecord/index.vue"
import { defineComponent, reactive, toRefs, ref } from 'vue';
import { useRouter } from 'vue-router'
import { ElMessage } from 'element-plus'
declare const window: any;
export default defineComponent({
  components:{
      Header,
      Banner,
      Works,
      WithdrawlRecord
  },
  setup(){
    const validatePass = (rule:any, value:string, callback:any) => {
      if (value === '') {
        callback(new Error('Required'));
      } else {
        if (data.form.checkPass !== '') {
          data.ruleForm.validateField('checkPass');
        }
        callback();
      }
    };
    const validatePass2 = (rule:any, value:string, callback:any) => {
      if (value === '') {
        data.paypalFlag = false
        callback(new Error('Required'));
      } else if (value !== data.form.paypalAccount) {
          data.paypalFlag = false
        callback(new Error('The two paypalAccount are inconsistent!'));
      } else {
          data.paypalFlag = true
        callback();
      }
    };
    const validatePhoneNum = (rule:any, value:string, callback:any) => {
      if (value === '') {
        data.phoneFlag = false
        callback(new Error('Required'));
      } else {
        data.phoneFlag = true
        callback();
      }
    };
    // const router = useRouter()
    
    interface DataProps{
      form:{
        firstName: string,
        lastName: string,
        email: string,
        paypalAccount: string,
        checkPass: string,
        phoneNum: string,
        joinReason: string,
        goodFit: string,
        checkedA:boolean,
        checkedB:boolean,
        checkedC:boolean
      },
      ruleForm: any,
      phoneFlag: boolean,
      paypalFlag: boolean,
      dialogTableVisible: boolean,
      submitBtnDisabled: boolean
    }
    const data:DataProps = reactive({
        submitBtnDisabled: true,
        paypalFlag: true,
        phoneFlag: true,
        dialogTableVisible: false,
        ruleForm: ref(null),
        form:{
            firstName: '',
            lastName: '',
            email: '',
            paypalAccount: '',
            checkPass: '',
            phoneNum: '',
            joinReason: '',
            goodFit: '',
            checkedA:false,
            checkedB:false,
            checkedC:false
        },
        rules:{
            firstName: [{ required: true, message: 'Required', trigger: 'blur' }],
            lastName: [{ required: true, message: 'Required', trigger: 'blur' }],
            email: [{ required: true, message: 'Required', trigger: 'blur' }],
            paypalAccount: [{ validator: validatePass, trigger: 'blur' }],
            checkPass: [{ validator: validatePass2, trigger: 'blur' }],
            phoneNum: [{ validator: validatePhoneNum, trigger: 'blur' }],
            joinReason: [{ required: true, message: 'Required', trigger: 'blur' }],
            goodFit: [{ required: true, message: 'Required', trigger: 'blur' }],
        },
        flag:true,
        submit:()=>{
            data.ruleForm.validate((valid:boolean)=>{
                if (valid) {
                    if(!data.form.checkedA || !data.form.checkedB || !data.form.checkedC){
                        ElMessage.error('Please check')
                        return false
                    }
                    edit(data.form).then(res=>{
                        const result = res as any
                        if(result.code === 200){
                            ElMessage.success('ok')
                            data.dialogTableVisible = true
                        }else{
                            ElMessage.error(result.msg)
                        }
                    })
                } else {
                    console.log('error submit!!');
                    return false;
                }
            })
        },
        goNonda:()=>{
            window.open('https://www.nonda.co',"_blank")
        },
        handleCheckd:(val:boolean)=>{
            if(data.form.checkedA && data.form.checkedB && data.form.checkedC){
                data.submitBtnDisabled = false
            }else{
                data.submitBtnDisabled = true
            }
            console.log(val)
        }

    })
    const refData = toRefs(data)
    return {
      ...refData
    }
  }
  
})
</script>

<style lang="scss" scoped>
    ::v-deep .el-dialog{
        width: 600px !important;
    }
    ::v-deep .el-dialog__header{
        padding: 0;
    }
    ::v-deep .el-divider{
        background-color: #e8e8e8;
        .el-divider__text{
          color: #9E9E9F;
          font-size: 18px;
        }
    }
    ::v-deep .el-form-item{
        margin: 0 auto 16px;
    }
    ::v-deep .change-form-c .el-form-item{
        margin: 0 auto 0;
    }
    ::v-deep .ipt-form-c .el-form-item{
        width: 70%;
    }
    ::v-deep .texteray-c  .el-form-item{
        width: 70%;
    }
    ::v-deep .checkbox-c{
        width: 70%;
        margin: 0 auto;
    }
    ::v-deep .checkbox-c .el-form-item{
        width: 100%;
        margin: 0px auto 2px;
    }
    ::v-deep .el-checkbox{
        margin: 0 auto;
        display: flex;
        white-space: normal !important;
        text-align: left;
        align-items: center;
    }
    ::v-deep .checkbox-c .el-form-item__content{
        line-height: 14px;
    }
    ::v-deep .el-checkbox .el-checkbox__label{
        font-size: 12px;
    }
    ::v-deep .el-textarea__inner::-webkit-input-placeholder{
          font-family: Avenir, Helvetica, Arial, sans-serif;
    }
    ::v-deep .el-checkbox__input.is-checked+.el-checkbox__label{
        color: #606266;
    }
    ::v-deep .el-button.is-disabled.el-button--text{
        background-color:rgba(0,0,0,.5);
        border:none;
    }
    .ipt-icon{
        width:16px;
        margin:12px 0 0 6px;
    }
    .home{
        overflow: hidden;
    }

    .wrap-c {
        max-width: 1024px;
        height: 100%;
        margin: 0 auto;
        overflow: hidden;
    }
    .form-title{
        margin-bottom: 20px;
    }
    .content{
        .work{
            background-color: #f2f2f2;
        }
        .content-c{
            padding: 20px 0;
            .form-c{
                max-width: 820px;
                margin: 0 auto;
                .text-c{
                    font-size:12px;
                    width: 70%;
                    margin: 0px auto 20px;
                    text-align: left;
                    line-height: 16px;
                }
                .input-c{
                    width: 70%;
                    margin: 0 auto;
                }
            }
        }
    }
    .withdraw-btn{
        font-weight: bold;
        width: 300px;
        margin: 20px auto 10px;
        color: #fff;
        background-color: #c51a1b;
        border-radius: 5px;
        border-color: #c51a1b;
        cursor: pointer;
        &:hover{
            transition: all 0.2s linear;
            background-color: #990000;
        }
    }
    .footer-nav{
        width: 100%;
        text-align: center;
        line-height: 50px;
        height: 50px;
        background-color: #000;
        color: #fff;
    }
    .dialog-box{
        text-align: left;
        line-height: 20px;
        font-weight: 500;
        word-break: normal;
    }
     @media screen and (max-width: 768px) {
        ::v-deep .el-dialog{
            width: 90% !important;
        }
         ::v-deep .checkbox-c{
             width: 100%;
         }
        .wrap-c {
            padding: 0 10px;
        }
        .content{
          
        }
    }
</style>
